module.exports = __webpack_public_path__ + "img/0Q3B7249_Black_MockedUp.5ba55aff.jpg";